module.exports = __webpack_public_path__ + "static/media/requests.802a328c.svg";